import { render, staticRenderFns } from "./explain-section-selector.component.vue?vue&type=template&id=7e079e0f&scoped=true"
import script from "./explain-section-selector.component.vue?vue&type=script&lang=ts"
export * from "./explain-section-selector.component.vue?vue&type=script&lang=ts"
import style0 from "./explain-section-selector.component.vue?vue&type=style&index=0&id=7e079e0f&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7e079e0f",
  null
  
)

export default component.exports